package uk.co.nickthecoder.kyd.appearance

import uk.co.nickthecoder.kyd.Actor
import uk.co.nickthecoder.kyd.ParentResource
import uk.co.nickthecoder.kyd.ResourceType

/**
 * A rectangular region of a [Graphic] (which _may_ be the graphic's entire area) which is
 * divided into 9 patches in a grid pattern.
 *
 * It can be drawn at any size without scaling the entire image.
 * Instead, the central patch is scaled in X & Y.
 * The top-center and bottom-center patches are scaled in X only.
 * The middle-left and middle-right patches are scaled in Y only.
 * The corner patches are not scaled.
 *
 * Used for button backgrounds, rectangular frames, speech bubbles.
 *
 * Note, this is _not_ an [Appearance], see [NinePatchAppearance].
 */
class NinePatch(
    parent: ParentResource,
    name: String,
    graphicPath: String

) : PartialGraphic(parent, name, graphicPath), AppearanceResource {

    override fun appearanceForActor(actor: Actor): NinePatchAppearance {

        return NinePatchAppearance(this).apply {
            val oldBounds = actor.appearance.localBounds()
            // For a "new" actor (in the editor), we use the "default" size,
            // but when the actor already HAS bounds, then we use its previous bound.
            if (oldBounds !== NoAppearance.NO_BOUNDS) {
                corner0 = oldBounds.first
                corner2 = oldBounds.second
            }
            tint = actor.appearance.tintIfAvailable
        }
    }

    override fun appearance() = NinePatchAppearance(this)

    override val resourceType: ResourceType
        get() = ResourceType.NINE_PATCH

    /**
     *
     */
    var margins = Margins()

}


